import { testType } from "../../utils/testHelper";
import Styles from "./examCard.module.css";
import { Grid, Tooltip } from "@mui/material";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import { useUserStore } from "../../hooks/store";
import { useModal } from "../../hooks/modalStore";
import { getLog } from "../../utils/API/userMethod";
import SolvingHistoryGrid from "../SolvingHistoryGrid/SolvingHistoryGrid";
import SolvingHistoryButton from "../SolvingHistoryButton";

export function ExamCard({
  size,
  imgSrc,
  title,
  questions,
  solved,
  onClick,
  type,
  biletId,
  themeId,
}) {
  return (
    <Grid size={size}>
      <div className={`${Styles.exam_card} ${questions == 0 && "disabled"}`}>
        <div className={Styles.history_icon}>
          <SolvingHistoryButton
            title={"История решений"}
            biletId={biletId}
            themeId={themeId}
            type={type}
            questions={questions}
          />
        </div>
        <img src={imgSrc} />
        <div className={Styles.exam_text} onClick={onClick}>
          <h6>{title}</h6>
          <div className={Styles.exam_card_info}>
            <p
              className={
                type == testType.bilet.type
                  ? solved > 18
                    ? "correct"
                    : solved == 0
                    ? Styles.exam_card_not_solved
                    : "wrong"
                  : solved == 0
                  ? Styles.exam_card_not_solved
                  : solved == questions
                  ? "correct"
                  : "wrong"
              }>
              {solved}
            </p>
            <p>/{questions}</p>
          </div>
        </div>
      </div>
    </Grid>
  );
}
